import UcFixedAssetTypeBadge from './UcFixedAssetTypeBadge.yaml?component';

export { UcFixedAssetTypeBadge };
